import { addDays, addHours, format, formatISO, startOfWeek } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { addMinutes, parseJSON } from 'date-fns/esm';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks/useRedux';
import { updateCalender, updateProfile } from '../reducers/profileSlice';
import Calender from './Calender/Calender';
import CalenderProvider from './Calender/CalenderContext';
import { Button } from '@wot/components';

const TIMES = [
  '12:00 AM',
  '1:00 AM',
  '2:00 AM',
  '3:00 AM',
  '4:00 AM',
  '5:00 AM',
  '6:00 AM',
  '7:00 AM',
  '8:00 AM',
  '9:00 AM',
  '10:00 AM',
  '11:00 AM',
  '12:00 PM',
  '1:00 PM',
  '2:00 PM',
  '3:00 PM',
  '5:00 PM',
  '6:00 PM',
  '7:00 PM',
  '8:00 PM',
  '9:00 PM',
  '10:00 PM',
  '11:00 PM',
  '11:00 PM'
];

const MIN_DAYS_TO_SELECT = 52;
interface ITimeslot {
  start: string;
  end: string;
}

interface Props {
  mode?: 'view' | 'edit';
  setCalenderVisibility?: any;
}

export default function SetCalender({ mode = 'edit', setCalenderVisibility }: Props) {
  const { profile } = useAppSelector((state) => state.profileSlice);
  const [bookedSlots, setBookedSlots] = useState<ITimeslot[]>(profile?.calender || []);
  const [, setToday] = useState(startOfWeek(new Date()));
  const { timezone } = useAppSelector((state) => state.preferencesSlice);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmit = () => {
    setLoading(true);
    dispatch(updateCalender(bookedSlots)).then(() => {
      dispatch(updateProfile({ status: 'active' })).then(() => {
        setLoading(false);
        setCalenderVisibility(false);
      })
    }).catch(err => setLoading(false));
  };


  return (
    <div className="w-full h-full flex flex-col">
      <div className="w-full h-full flex flex-col md:flex-row items-stretch gap-2">
        <div className="w-full md:w-3/4 max-h-[600px] flex flex-col p-2">
          <CalenderProvider>
            <Calender
              slotSelectable
              recurrence
              onReccurence={(slots: any) => {
                setBookedSlots(slots)
              }}
              selectedSlots={bookedSlots}
              onSelectSlot={(slot: any, remove?: number) => {
                if (remove) {
                  setBookedSlots(bookedSlots.filter((s) => s.start !== slot.start && s.end !== slot.end));
                } else {
                  setBookedSlots([...bookedSlots, slot]);
                }
              }}
            />
          </CalenderProvider>
          {/* <div className="w-full flex gap-5 items-center justify-center py-4">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-[#9AD366] p-2 rounded-full"></div>
              <h4 className="text-sm font-normal">Available</h4>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-[#C4C4C4] p-2 rounded-full"></div>
              <h4 className="text-sm font-normal">Not Available</h4>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-secondary p-2 rounded-full"></div>
              <h4 className="text-sm font-normal">Selected</h4>
            </div>
          </div> */}
        </div>

        {mode === 'edit' && (
          <div className="w-full md:w-1/4 flex flex-col gap-2">
            <div className="w-full p-4 text-sm bg-neutralBlue2 text-primary">
              <span className="font-medium">Note: </span>
              Number of available days to be set as {MIN_DAYS_TO_SELECT} days.
            </div>

            <div className="w-full flex flex-col gap-2 px-4 py-2 text-sm bg-neutralBlue2 text-primary">
              <h3 className="text-base font-medium">
                {bookedSlots.length} <span className="text-sm text-gray-400">Slots Selected</span>
              </h3>
              {bookedSlots.length < MIN_DAYS_TO_SELECT && (
                <div className="flex items-start">
                  <p className="text-xs text-red-400">
                    You still have to select {MIN_DAYS_TO_SELECT - bookedSlots.length} more slots to submit the
                    availability
                  </p>
                </div>
              )}
            </div>

            <div className="w-full flex flex-col gap-2 px-4 py-2 text-sm bg-neutralBlue2 text-primary overflow-hidden">
              <div className="w-full">
                <h1>All</h1>
              </div>
              <div className="w-full max-h-[440px] flex flex-col gap-2 overflow-y-scroll">
                {bookedSlots.map((slot, index) => (
                  <div
                    key={index}
                    onClick={() => setToday(startOfWeek(new Date(slot.start)))}
                    className="w-full p-4 bg-white border border-l-4 border-neutralGray3 rounded-md flex items-start gap-4 cursor-pointer"
                  >
                    <div className="flex flex-col items-start border-r pr-2">
                      <p className="text-sm font-semibold">{formatInTimeZone(parseJSON(slot.start), timezone, 'd')}</p>
                      <p className="text-xs font-semibold">
                        {formatInTimeZone(parseJSON(slot.start), timezone, 'MMM')}
                      </p>
                    </div>

                    <div className="flex flex-col items-start">
                      <p className="text-xs font-semibold">
                        {formatInTimeZone(parseJSON(slot.start), timezone, 'eeee')}
                      </p>
                      <p className="text-sm font-semibold">
                        {formatInTimeZone(parseJSON(slot.start), timezone, 'p')} -{' '}
                        {formatInTimeZone(parseJSON(slot.end), timezone, 'p')}
                      </p>
                    </div>
                    <div className="ml-auto"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
      {mode === 'edit' && (
        <div className="min-w-[164px] mx-auto flex items-center justify-center py-5">
          <Button loading={loading} disabled={bookedSlots.length < MIN_DAYS_TO_SELECT} text="Submit" onClick={() => onSubmit()} />
        </div>
      )}
    </div>
  );
}

export function CalenderWeekView({
  today,
  handleSlotChange,
  timeslots
}: {
  today: any;
  handleSlotChange: (slot: ITimeslot, remove?: boolean) => void;
  timeslots: ITimeslot[];
}) {
  return (
    <div className="w-full max-h-[500px] grow bg-white flex flex-col border rounded-md">
      <div className="w-full flex pr-[3px] ">
        <HeaderCell text={format(today, 'z')} />
        {[...new Array(7)].map((_, i) => (
          <HeaderCell key={i} text={format(addDays(startOfWeek(today), i), 'eee d')} />
        ))}
      </div>

      <div className="w-full flex overflow-hidden overflow-y-scroll custom-scrollbar">
        <div className="w-full flex flex-col">
          {TIMES.map((time, hour) => (
            <TimeCell key={hour} text={time}>
              <>
                {[...new Array(7)].map((_, weekNo) => (
                  <Slot
                    key={weekNo}
                    timeslots={timeslots}
                    timeslot={formatISO(addHours(addDays(startOfWeek(today), weekNo), hour))}
                    onClick={(timeslot: string, remove?: boolean) => {
                      handleSlotChange(
                        {
                          start: timeslot,
                          end: formatISO(addHours(parseJSON(timeslot), 1))
                        },
                        remove
                      );
                    }}
                  />
                ))}
              </>
            </TimeCell>
          ))}
        </div>
      </div>
    </div>
  );
}

const HeaderCell = ({ text }: { text: string }) => {
  return (
    <div className="w-full p-4 flex bg-gray-100 items-center justify-center basis-0 grow border">
      <p className="text-sm">{text}</p>
    </div>
  );
};

function TimeCell({ text, children }: { text: string; children: JSX.Element }) {
  return (
    <div className="w-full h-full flex ">
      <div className="w-full pb-4 flex flex-col bg-white items-center justify-center basis-0 grow border">
        <p className="text-sm pb-4">{text}</p>
        <p className="text-sm">{text.replace('00', '30')}</p>
      </div>
      {children}
    </div>
  );
}

function Slot({ timeslot, onClick, timeslots }: { timeslot: any; onClick: any; timeslots: ITimeslot[] }) {
  const [slotStatus, setSlotStatus] = useState({
    booked: false,
    minutes: 0
  });
  useEffect(() => {
    let x = timeslots.some((item) => item.start === timeslot);
    if (x) {
      setSlotStatus({
        booked: true,
        minutes: 0
      });
      return;
    }
    let y = timeslots.some((item) => item.start === formatISO(addMinutes(parseJSON(timeslot), 30)));
    if (y) {
      setSlotStatus({
        booked: true,
        minutes: 30
      });
      return;
    }
    setSlotStatus({
      booked: false,
      minutes: 0
    });
  }, [timeslots, timeslot]);

  return (
    <div className="relative w-full h-full  flex bg-gray-100 basis-0  grow border">
      <div className="w-full flex flex-col">
        <div onClick={() => onClick(timeslot)} className="w-full h-1/2"></div>
        <div
          onClick={() => onClick(formatISO(addMinutes(parseJSON(timeslot), 30)))}
          className="w-full h-1/2 border-t"
        ></div>
      </div>
      {slotStatus.booked && (
        <div
          onClick={() => onClick(formatISO(addMinutes(parseJSON(timeslot), slotStatus.minutes)), true)}
          className={`absolute w-full h-full ${slotStatus.minutes === 30 ? 'top-1/2' : 'top-0'
            } left-0 z-50 bg-green-400 cursor-pointer`}
        ></div>
      )}
    </div>
  );
}
